import React from 'react'
import P5Wrapper from 'react-p5-wrapper'

const canvasSize = 800
const IMAGE_DIMENSIONS = { width: 1920, height: 1080 }
const ASPECT_RATIO = IMAGE_DIMENSIONS.width / IMAGE_DIMENSIONS.height

function sketch(p) {
	p.disableFriendlyErrors = true

	let rotation = (PatternTriangles.defaultProps.rotation * Math.PI) / 180
	let patternX = PatternTriangles.defaultProps.patternX
	let patternY = PatternTriangles.defaultProps.patternY
	let shapeSize = PatternTriangles.defaultProps.shapeSize
	let colors = PatternTriangles.defaultProps.colors
	let bg = PatternTriangles.defaultProps.backgroundColor
	let lastCanvasWidth = canvasSize
	let lastCanvasHeight = canvasSize
	let canvasWidth = canvasSize
	let canvasHeight = canvasSize

	let pg = null

	p.setup = function () {
		p.pixelDensity(2)
		p.createCanvas(canvasSize, canvasSize)

		pg = p.createGraphics(
			IMAGE_DIMENSIONS.width,
			IMAGE_DIMENSIONS.height,
			p.P2D
		)
		pg.background(bg)
		p.background(bg)

		p.noLoop()
	}

	p.saveImage = function () {
		pg.save(pg, 'pattern-' + new Date().toISOString() + '.png')
	}

	p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
		if (props.rotation !== null) {
			rotation = (props.rotation * Math.PI) / 180
		}
		if (props.patternX !== null) {
			patternX = props.patternX
		}
		if (props.patternY !== null) {
			patternY = props.patternY
		}
		if (props.shapeSize !== null) {
			shapeSize = props.shapeSize
		}
		if (props.colors !== null) {
			colors = props.colors
		}
		if (props.backgroundColor !== null) {
			bg = props.backgroundColor
		}
		if (props.width !== null || props.height !== null) {
			canvasWidth = props.width
			canvasHeight = props.height
		}
		if (props.export() !== null) {
			if (props.export() === true) {
				p.saveImage()
			}
		}
		p.redraw()
	}

	p.draw = function () {
		if (canvasWidth !== lastCanvasWidth || canvasHeight !== lastCanvasHeight) {
			p.resizeCanvas(canvasWidth, canvasHeight)
			lastCanvasWidth = canvasWidth
			lastCanvasHeight = canvasHeight
		}
		pg.noStroke()

		pg.background(bg)

		const size =
			IMAGE_DIMENSIONS.width / Math.floor(IMAGE_DIMENSIONS.width / shapeSize)
		const pattern = [patternX, patternY]

		let i = 0
		for (let y = 0; y * size < IMAGE_DIMENSIONS.height + size; y++) {
			for (let x = 0; x * size < IMAGE_DIMENSIONS.width + size; x++) {
				pg.push()
				pg.fill(colors[i % colors.length])
				// p.fill(
				//     colors[(i + Math.floor(Math.random() * 3)) % colors.length]
				// )
				pg.translate(x * size, y * size)
				pg.rotate(rotation)
				pg.triangle(
					0,
					0,

					pattern[y % pattern.length][x % pattern[y % pattern.length].length]
						? size
						: -size,
					0,
					0,

					pattern[x % pattern.length][y % pattern[x % pattern.length].length]
						? size
						: -size
				)

				pg.pop()
				i++
			}
		}

		let zoomFactor = 1
		if (canvasWidth / canvasHeight > ASPECT_RATIO) {
			// Landscape
			//zoomFactor = canvasWidth > 2 * canvasHeight ? 1.5 : 1
			p.image(
				pg,
				0,
				0,
				canvasWidth * zoomFactor,
				(canvasWidth / ASPECT_RATIO) * zoomFactor
			)
		} else {
			// Portrait
			//zoomFactor = canvasWidth > canvasHeight ? 1.25 : 1.5
			p.image(
				pg,
				0,
				0,
				ASPECT_RATIO * canvasHeight * zoomFactor,
				canvasHeight * zoomFactor
			)
		}
	}
}

export default function PatternTriangles(props) {
	return <P5Wrapper sketch={sketch} {...props} />
}

PatternTriangles.defaultProps = {
	width: canvasSize,
	height: canvasSize,
	rotation: 0,
	patternX: [true, false, false],
	patternY: [true, false, true],
	shapeSize: 20,
	colors: ['#FFFFFF', '#C800FF', '#0015D6', '#FF005D', '#43C9CB'],
	backgroundColor: '#000000',
	export: () => false,
}
